import { render } from "./doctor-clinic-settings.vue?vue&type=template&id=985bd1ac&scoped=true"
import script from "./doctor-clinic-settings.vue?vue&type=script&lang=js"
export * from "./doctor-clinic-settings.vue?vue&type=script&lang=js"

import "./doctor-clinic-settings.vue?vue&type=style&index=0&id=985bd1ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-985bd1ac"]])

export default __exports__